module.exports = __webpack_public_path__ + "static/media/partyverse.1ff239e4.png";